import React from 'react';
import { Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { uniq, upperFirst } from 'lodash';
import { COLORS } from './colors';
import { GetDashboardPreference_vm_profile_dashboardPreference_dashboardComponents_widget_VOLUNTEER_ChartWidgetType as IChartWidget } from '../../dashboard-widget-setting/__generated__/GetDashboardPreference';
import { useQueryChart } from './useQueryChart';

type DashboardLineChartProps = {
  widget: IChartWidget;
};

export function DashboardLineChart(props: DashboardLineChartProps) {
  const { widget } = props;
  const { group } = widget.configuration;

  const data = useQueryChart(widget);

  if (!data) {
    return null;
  }

  if (group === null) {
    const keys = uniq(
      data.flatMap((datum: { [key: string]: number }) => Object.keys(datum).filter((key) => key !== 'date'))
    ) as string[];
    return (
      <ResponsiveContainer width='100%' height='99%'>
        <LineChart
          data={data}
          margin={{
            top: 5,
            right: 0,
            left: 5,
            bottom: 5,
          }}
        >
          <XAxis dataKey='date' />
          <YAxis />
          <Tooltip />
          <Legend iconType='circle' iconSize={10} />
          {keys.map((key: string, index: number) => (
            <Line key={key} dataKey={key} name={upperFirst(key)} stroke={COLORS[index]} />
          ))}
        </LineChart>
      </ResponsiveContainer>
    );
  }
  if (!data.data || data.data.length === 0) {
    return null;
  }
  const keys = uniq(
    data.data.flatMap((datum: { [key: string]: number }) => Object.keys(datum).filter((key) => key !== 'date'))
  ) as string[];
  return (
    <ResponsiveContainer width='100%' height='99%'>
      <LineChart
        data={data.data}
        margin={{
          top: 5,
          right: 5,
          left: 5,
          bottom: 5,
        }}
      >
        <XAxis dataKey='date' />
        <YAxis />
        <Tooltip />
        <Legend iconType='circle' iconSize={10} />
        {keys.map((key: string, index: number) => (
          <Line key={key} dataKey={key} name={upperFirst(key)} stroke={COLORS[index]} strokeWidth={3} />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
}
